import {
  useElement,
  useState,
  useStaleLayout,
  useRect,
  useEffect,
} from '@nebula.js/stardust';
import picassojs from 'picasso.js';
import picassoQ from 'picasso-plugin-q';
import numeral from 'numeral';
import * as d3 from 'd3';

export default function supernova() {
  const picasso = picassojs();
  picasso.use(picassoQ);

  return {
    qae: {
      properties: {
        qHyperCubeDef: {
          qDimensions: [],
          qMeasures: [],
          qInitialDataFetch: [{ qWidth: 2, qHeight: 5000 }],
          qSuppressZero: false,
          qSuppressMissing: true,
        },
        showTitles: true,
        title: '',
        subtitle: '',
        footnote: '',
      },
      data: {
        targets: [
          {
            path: '/qHyperCubeDef',
            dimensions: {
              min: 1,
              max: 1,
            },
            measures: {
              min: 1,
              max: 1,
            },
          },
        ],
      },
    },
    component() {
      const element = useElement();
      const layout = useStaleLayout();
      const rect = useRect();

      const [instance, setInstance] = useState();

      useEffect(() => {
        const p = picasso.chart({
          element,
          data: [],
          settings: {},
        });

        setInstance(p);

        return () => {
          p.destroy();
        };
      }, []);

      useEffect(() => {
        if (!instance) {
          return;
        }

        const colorScale = d3.scaleOrdinal()
          .domain(['Men', 'Women', 'Non-Binary'])
          .range(['#9EBFCE', '#BE7999', '#204635']);

        instance.update({
          data: [
            {
              type: 'q',
              key: 'qHyperCube',
              data: layout.qHyperCube,
            },
          ],
          settings: {
            scales: {
              color: {
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                  },
                },
                type: 'color',
              },
            },
            components: [
              {
                key: 'donut',
                type: 'pie',
                data: {
                  extract: {
                    field: 'qDimensionInfo/0',
                    props: {
                      num: {
                        field: 'qMeasureInfo/0',
                      },
                    },
                  },
                },
                settings: {
                  padAngle: 0.01,
                  slice: {
                    cornerRadius: 0,
                    innerRadius: 0.4,
                    arc: {
                      ref: 'num',
                    },
                    fill: (d) => colorScale(d.datum.label),
                    strokeWidth: 1,
                    stroke: 'rgba(255,255,255,0.5)',
                  },
                },
              },
              {
                type: 'labels',
                displayOrder: 2,
                settings: {
                  sources: [
                    {
                      component: 'donut',
                      selector: 'path',
                      strategy: {
                        type: 'slice',
                        settings: {
                          direction: 'horizontal',
                          fontSize: 11,
                          align: 0.5,
                          justify: 1,
                          labels: [
                            {
                              label: (d) => numeral(d.data.num.value).format('0.0%'),
                              fill: '#FFFFFF',
                              placements: [
                                { position: 'into', fill: '#fff' },
                                { position: 'outside', fill: '#666' },
                              ],
                            },
                          ],
                        },
                      },
                    },
                  ],
                },
              },
            ],
            interactions: [],
          },
        });
      }, [layout, instance]);

      useEffect(() => {
        if (!instance) {
          return;
        }
        instance.update();
      }, [rect.width, rect.height, instance]);
    },
  };
}
